import type { StaffMember } from '../types';

export const initialStaff: StaffMember[] = [
    { id: 1, name: 'Jane Doe', role: 'manager', pin: '1234' },
    { id: 2, name: 'John Smith', role: 'waitstaff', pin: '5678' },
    { id: 3, name: 'Peter Jones', role: 'chef', pin: '1122' },
    { id: 4, name: 'Mary Williams', role: 'cashier', pin: '3344' },
    { id: 5, name: 'David Brown', role: 'waitstaff', pin: '9876' },
];
